'use client';

import styles from './Device.module.scss';

interface DeviceProps {
  /** Toggle visibility of notch. Defaults to `true` */
  notch?: boolean;
  /** Disable the screen GPU transform fix. Useful for libraries that rely on fixed-position drag layers. */
  disableScreenGpuTransform?: boolean;
  type: 'iphone';
}

const Device: React.FC<React.PropsWithChildren<DeviceProps>> = ({
  type,
  children,
  notch = true,
  disableScreenGpuTransform = false,
}) => {
  switch (type) {
    case 'iphone':
      return (
        <div className={styles['iphone-14']}>
          <div className={styles['iphone-14-content']}>
            {notch && (
              <div className={styles['notch']}>
                <div className={styles['camera']}></div>
              </div>
            )}
            {/* <div className={styles["top-bar"]}></div> */}
            <div className={styles['sleep']}></div>
            {/* <div className={styles["bottom-bar"]}></div> */}
            <div className={styles['volume']}></div>
            <div className={styles['overflow']}>
              <div className={`${styles['shadow']} ${styles['shadow--tr']}`}></div>
              <div className={`${styles['shadow']} ${styles['shadow--tl']}`}></div>
              <div className={`${styles['shadow']} ${styles['shadow--br']}`}></div>
              <div className={`${styles['shadow']} ${styles['shadow--bl']}`}></div>
            </div>
            <div className={styles['inner-shadow']}></div>
            <div
              className={styles['screen']}
              data-notch={notch}
              data-screen-gpu-transform={disableScreenGpuTransform ? 'false' : 'true'}
            >
              {children}
            </div>
          </div>
        </div>
      );
    default:
      return <></>;
  }
};

export default Device;
